import Swiper, { Pagination, Navigation, Mousewheel } from 'swiper';

Swiper.use([Pagination, Navigation, Mousewheel]);

var Slideshows = function () {

  if (jQuery('.single-courses-slideshow').length > 0) {
    var _loop = false;
    if (jQuery('.single-courses-slideshow .swiper-slide').length > 3) {
      _loop = true;
    }
    var swiper = new Swiper('.single-courses-slideshow', {
      slidesPerView: 1,
      autoHeight: true,
      grabCursor: true,
      loop: false,
      spaceBetween: 15,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        nextEl: ".single-courses-slideshow .swiper-button-next",
        prevEl: ".single-courses-slideshow .swiper-button-prev",
      },
      lazy: {
        loadOnTransitionStart: true,
        loadPrevNext: true,
      },
      breakpoints: {
        901: {
          slidesPerView: "auto",
          autoHeight: false,
        }
      }
    });

    const lazyImages = document.querySelectorAll('.single-courses-slideshow img[loading="lazy"]');
    lazyImages.forEach((img) => {
        img.addEventListener('load', () => {
            swiper.update();
        });
    });
  }

  if (jQuery('.single-seminars-slideshow').length > 0) {
    var _loop = false;
    if (jQuery('.single-seminars-slideshow .swiper-slide').length > 3) {
      _loop = true;
    }
    setTimeout(function () {
      new Swiper('.single-seminars-slideshow', {
        slidesPerView: '1',
        grabCursor: true,
        loop: false,
        autoHeight: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          nextEl: ".single-seminars-slideshow .swiper-button-next",
          prevEl: ".single-seminars-slideshow .swiper-button-prev",
        }
      });
    }, 100);
  }

  if (jQuery('.swiper-default').length > 0) {
    var _loop = false;
    if (jQuery('.swiper-default .swiper-slide').length > 1) {
      _loop = true;
    }
    setTimeout(function () {
      new Swiper('.swiper-default', {
        slidesPerView: '1',
        grabCursor: true,
        loop: false,
        autoHeight: false,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        navigation: {
          nextEl: ".swiper-default .swiper-button-next",
          prevEl: ".swiper-default .swiper-button-prev",
        }
      });
    }, 100);
  }
};

module.exports = Slideshows;
